module.exports = __webpack_public_path__ + "947961b2ce934e2f15c945c944670c91.svg";


//////////////////
// WEBPACK FOOTER
// ../images/icons/svg/icon-thumbsup-white-blue-bg.svg
// module id = 1022
// module chunks = 69